'use strict';

angular.module('internal.licenses')
    .controller('InternalLicenseFormBuilder', ['$rootScope', '$scope', 'FBForms', 'DataSets', '$state', '$uibModal', 'FBElements', '$q',
        function ($rootScope, $scope, FBForms, DataSets, $state, $uibModal, FBElements, $q) {
        $scope.resetForm();
        $scope.dataSets = [];
        $scope.elements = [];
        $scope.saving = false;
        $scope.saveSuccess = false;
        $scope.deleting = false;
        $scope.loading = true;
        $scope.creatingView = false;
        $scope.isSuperUser = $rootScope.userAccount.super;
        $scope.parameters = { license_id: $scope.licenseID };
        $scope.vm = {
            attachments: [],
            changesMade: false
        }
        $scope.messages = [];

        var a = DataSets.get($scope.licenseID).then(function (dataSets) {
            $scope.dataSets = dataSets;
        });

        var b = FBElements.get({ license_id: $scope.licenseID }).then(function (elements) {
            $scope.elements = elements;
        });

        $q.all([a, b]).then(function () {
            $scope.loading = false;
        }).catch(function (response) {
            // handle error
        });

        if ($scope.form.the_form) {
            $scope.form.the_form = {};
        }

        // Watch for form changes to reset save success message
        $scope.$watch('form.the_form.$dirty', function (isDirty) {
            if (isDirty) {
                $scope.saveSuccess = false;
            }
        });

        $scope.activePage = function () {
            for (var i = 0; i < $scope.form.pages.length; i++) {
                var page = $scope.form.pages[i];
                if (page.tab_active) {
                    return i;
                }
            }
            return 0;
        }

        $scope.createView = function () {
            $scope.creatingView = true;
            FBForms.createView($scope.formID).then(function () {
                $scope.creatingView = false;
            });
        };

            function doParenthesesMatch(conditions) {
                var parenthesisString = '';
                for (var i = 0; i < conditions.length; i++)
                {
                    var left = "", right = "";
                    if (conditions[i].left_parenthesis === undefined) {
                        left = '';
                    }
                    else if (conditions[i].left_parenthesis == 1) {
                        left = "(";
                    }
                    else if (conditions[i].left_parenthesis == 2) {
                        left = "((";
                    }
                    if (conditions[i].right_parenthesis === undefined) {
                        right = '';
                    }
                    else if (conditions[i].right_parenthesis == 1) {
                        right = ")";
                    }
                    else if (conditions[i].right_parenthesis == 2) {
                        right = "))";
                    }
                    parenthesisString += left + right;
                }

                var parenthesisStack = [];
                for (var i = 0; i < parenthesisString.length; i++) {
                    var char = parenthesisStack[parenthesisStack.length - 1];
                    if (parenthesisString.charAt(i) == "(") {
                        parenthesisStack.push(parenthesisString.charAt(i));
                    } else if (char == "(" && parenthesisString.charAt(i) == ")") {
                        parenthesisStack.pop();
                    } else {
                        return false;
                    }
                }

                window.scrollTo(0, 0);
                return (parenthesisStack.length) ? false : true;
            }

            $scope.closeSaveSuccess = function () {
                $scope.saveSuccess = false;
            };

            $scope.save = function () {
            if ($scope.form.the_form.$valid) {
                $scope.saving = true;
                $scope.saveSuccess = false;
                $scope.creatingView = false;
                $scope.oldActivePage = $scope.activePage();
                $scope.messages = [];
                var failed_count = 0;
                //Loop through each page
                $scope.form.pages.forEach(function (page) {
                    if (page.sections != null && page.sections.length > 0) {
                        //Loop through each section
                        page.sections.forEach(function (section) {
                            if (section.components != null && section.components.length > 0) {
                                //Loop through each component 
                                section.components.forEach(function (component) {
                                    if (failed_count > 0 || !doParenthesesMatch(component.component_conditions)) failed_count++;
                                    if (component.questions != null && component.questions.length > 0) {

                                        //Save non-empty questions.
                                        component.questions = component.questions.filter(function (question) {
                                            return (question.id !== undefined);
                                        });
                                    }
                                });
                                //Save non-empty components again on the way back out
                                section.components = section.components.filter(function (component) {
                                    if (component.id != undefined) {
                                        return (((component.component_type.code == 'custom' || component.component_type.code == 'dataset') && component.questions.length > 0) || (component.component_type.code != 'custom' && component.component_type.code != 'dataset' && component.component_type.code != null));
                                    }
                                });
                            }
                        });
                        //Save non-empty sections again on the way back out
                        page.sections = page.sections.filter(function (section) {
                            if (section.components != null) {
                                return (section.components.length > 0);
                            }
                        });
                    }
                });

                if (failed_count) {
                    $scope.messages.push('Validation failed! Please ensure parenthesis are valid.');
                    $scope.saving = false;
                }
                else
                {
                    FBForms.save({ form: $scope.form, license_id: $scope.licenseID }, $scope.vm.attachments).then(function (form) {

                        if (form != null) {
                            form.the_form = $scope.form.the_form;
                            form.the_form.$setPristine();
                            $scope.form = form;

                            if ($scope.form.pages != null && $scope.form.pages.length > 0) {
                                var activePage = $scope.form.pages[$scope.oldActivePage < $scope.form.pages.length ? $scope.oldActivePage : 0];
                                activePage.tab_active = true;

                                setTimeout(function () {
                                    var li = document.getElementById(activePage.id);
                                    var liSection = document.getElementById("sections");
                                    var liSectionPar = (liSection) ? liSection.parentElement : null;
                                    if (li) {
                                        li.classList.add('active');
                                    }
                                    if (liSectionPar) {
                                        liSectionPar.classList.add('active');
                                    }
                                }, 0);
                            }
                            angular.copy($scope.form, $scope.masterForm);
                        }

                        $scope.setMasterForm(form);

                        if (form != null && $scope.formID == null) {
                            $state.go('internal.licensing.license.form.builder', { formID: form.id, form: form });
                        }

                        $scope.saving = false;
                        $scope.saveSuccess = true;
                    }).catch(function (error) {
                        $scope.saving = false;
                        $scope.saveSuccess = false;
                    });
                }
            }
        }

        $scope.copy = function () {
            $scope.copying = true;
            var copiedForm = angular.copy($scope.form);
            copiedForm.name = 'Copy of ' + $scope.form.name;
            var licenseID = $scope.licenseID;

            var modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'templates/copy-form/copy-form.html',
                controller: 'CopyFormModalController',
                resolve: {
                    name: function() {
                        return copiedForm.name;
                    },
                    license_id: function() {
                        return licenseID;
                    },
                    license_category_id: function() {
                        return $scope.license.license_category_id;
                    }
                }
            });
            modalInstance.result.catch(function () {
                $scope.copying = false;
            });
            modalInstance.result.then(function (result) {
                if (result != null) {
                    copiedForm.name = result.name;
                    copiedForm.old_form_id = null;

                    FBForms.save({ form: copiedForm, license_id: result.licenseID, copy: true }).then(function (form) {
                        if (form != null) {
                            $state.go('internal.licensing.license.form.builder', { formID: form.id, form: form, id: result.licenseID, license: null });
                        }
                        $scope.copying = false;
                    });
                } else {
                    $scope.copying = false;
                };
            });
        }

        $scope.delete = function () {
            $scope.deleting = true;

            $uibModal.open({
                animation: true,
                templateUrl: 'templates/confirm/confirm.html',
                controller: 'ConfirmModalController',
                resolve: {
                    message: function() {
                        return "Are you sure you want to delete this form?";
                    }
                }
            }).result.then(function(result) {
                if (result) {
                    FBForms.delete($scope.formID).then(function() {
                        $scope.deleting = false;
                        updateArray($scope.license.forms, $scope.form, true);
                        updateArray($scope.masterLicense.forms, $scope.form, true);
                        $state.go('internal.licensing.license.forms.forms', { id: $scope.licenseID });
                    })
                } else {
                    $scope.deleting = false;
                }
            });
        }

        window.onbeforeunload = function (e) {
            if ($scope.formID == null) {
                updateArray($scope.license.forms, $scope.form, true);
                updateArray($scope.masterLicense.forms, $scope.form, true);
            }
            if ($scope.saving && $scope.formID != null) {
                e.returnValue = "Form is currently saving. Are you sure you want to leave?";
                return "Form is currently saving. Are you sure you want to leave?";
            }
            if ($scope.form.the_form != null && $scope.form.the_form.$dirty) {
                e.returnValue = "You have unsaved changes. Are you sure you want to leave?";
                return "You have unsaved changes. Are you sure you want to leave?";
            }
        };
        var cleanupStateChange = $scope.$on('$stateChangeStart', function (event, next, current) {
            if ($scope.formID == null) {
                updateArray($scope.license.forms, $scope.form, true);
                updateArray($scope.masterLicense.forms, $scope.form, true);
            }
            if ($scope.saving && $scope.formID != null) {
                if (!confirm("Form is currently saving. Are you sure you want to leave?")) {
                    event.preventDefault();
                }
            }
            else if ($scope.form.the_form != null && $scope.form.the_form.$dirty) {
                if (!confirm("You have unsaved changes. Are you sure you want to leave?")) {
                    event.preventDefault();
                }
            }
        });
        $scope.$on('$destroy', function () {
            cleanupStateChange();
        });
    }])
;